import { BLOCKS, Document } from "@contentful/rich-text-types";
import { IContentfulRichText, IRichTextReference } from "../types/IContentfulRichText";

export function generateRichTextRaw(nodeType: string, text: string) {
  return {
    // eslint-disable-next-line quotes
    raw: `{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],\
    "value":"${text}","nodeType":"text"}],\
    "nodeType":"${nodeType}"},{"data":{},"content":[{"data":{},"marks":[],\
    "value":"","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}`,
    references: [],
  };
}

export const generateRichText = (text: string): IContentfulRichText => ({
  json: {
    content: [
      {
        content: [
          {
            data: {},
            marks: [],
            nodeType: "text",
            value: text,
          },
        ],
        data: {},
        nodeType: BLOCKS.PARAGRAPH,
      },
    ],
    data: {},
    nodeType: BLOCKS.DOCUMENT,
  },
});

export const transformRichText = (
  rawData: string,
  nodeType?: string,
  references?: IRichTextReference[],
): IContentfulRichText => {
  const jsonObject = JSON.parse(rawData);
  const transformedData = {
    ...jsonObject,
    json: {
      content: jsonObject.content.map((c: Document) => {
        const newContent = {
          ...c,
          nodeType: nodeType || c.nodeType,
        };
        if (references && newContent.nodeType === BLOCKS.EMBEDDED_ASSET) {
          const reference = references.find(
            (r: IRichTextReference) => r.contentful_id === newContent.data.target.sys.id,
          );
          if (reference) {
            newContent.data.target.url = reference.file.url;
          }
        }
        return newContent;
      }),
    },
  };

  return transformedData;
};
